import { observable, action, intercept } from "mobx";
import { post } from "../services/ajax.service";

class RebateManagementStore {

  @observable report_response = "";
  @observable report_response_internal = "";
  @observable current_formulary_rebate = 0;
  @observable optimized_formulary_alt_rebate = 0;
  @observable optimized_formulary_total_saving = 0;
  @observable current_formulary_drugs = [];
  @observable optimized_formulary_drugs = [];
  @observable total_savings_lives = 0;
  @observable reportError = "";
  @observable total_available_savings = 0;
  @observable run_date = null;
  @observable url = "/api/v1/recommendationactions/RebateManagement";

  @action getCurrentFormulary = async (data) => {
    try {
      this.current_formulary_rebate = 0;
      let response = await post(
        `${this.url}/getCurrentFormulary`,
        data
      );

      this.current_formulary_rebate = response.data[0].total_rebates;

    } catch (err) {
      console.log(err);
    }
  }
  @action getTotalAvailableSavings = async (data) => {
    try {
      this.total_available_savings = 0;
      let response = await post(
        `${this.url}/getTotalAvailableSavings`,
        data
      );

      this.total_available_savings = response.data[0].total_available_savings;

    } catch (err) {
      console.log(err);
    }
  }

  @action get_run_date = async (data) => {
    try {
      this.run_date = null;
      let response = await post(
        `${this.url}/get_run_date`,
        data
      );

      this.run_date = response.data[0].run_date

    } catch (err) {
      console.log(err);
    }
  }

  @action getOptimizedFormulary = async (data) => {
    try {

      this.optimized_formulary_alt_rebate = 0;
      this.optimized_formulary_total_saving = 0;

      let response = await post(
        `${this.url}/getOptimizedFormulary`,
        data
      );

      this.optimized_formulary_alt_rebate = response.data[0].total_alt_rebates;
      this.optimized_formulary_total_saving = response.data[0].Total_Savings;

    } catch (err) {
      console.log(err);
    }
  }

  @action getOptimizedFormularyDrugs = async (data) => {
    try {
      this.optimized_formulary_drugs = [];
      let response = await post(
        `${this.url}/getOptimizedFormularyDrugs`,
        data
      );

      this.optimized_formulary_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  }
  @action generateXLSXReport = async (data) => {
    try {
      this.reportError = "";
      let response = await post(
        `${this.url}/generateXLSXReport`,
        data
      );
      this.report_response = response.data;
      return response.data;
    } catch (err) {
      this.reportError = err.response.data;
      this.report_response = err.response.data;
      return err.response.data;
    }
  }

  @action generateXLSXReportInternal = async (data) => {
    try {
      this.reportError = "";
      let response = await post(
        `${this.url}/generateXLSXReportInternal`,
        data
      );
      this.report_response_internal = response.data;
      return response.data;
    } catch (err) {
      this.reportError = err.response.data;
      this.report_response_internal = err.response.data;
      return err.response.data;
    }
  }

  @action getCurrentFormularyDrugs = async (data) => {
    try {
      this.current_formulary_drugs = [];
      let response = await post(
        `${this.url}/getCurrentFormularyDrugs`,
        data
      );

      this.current_formulary_drugs = response.data;
    } catch (err) {
      console.log(err);
    }
  }

  @action getSavingsTotalLivesAffected = async (data) => {
    try {
      this.total_savings_lives = [];
      let response = await post(
        `${this.url}/getSavingsTotalLivesAffected`,
        data
      );

      this.total_savings_lives = response.data[0].total_savings_lives;
    } catch (err) {
      console.log(err);
    }
  }

}
export default RebateManagementStore;
